import React, { useContext } from "react";
import PropTypes from "prop-types";
import Chart from "react-apexcharts";
import { Card, Subtitle } from "uikit/components";
import styles from "./SportsmanRelativeRating.module.styl";
import { MediaContext } from "app/media/MediaContext";

export default function SportsmanRelativeRating({ relativeRating }) {
    const { isDesktop } = useContext(MediaContext);

    const options = {
        labels: [""],
        fill: {
            type: "solid",
            colors: [relativeRating > 50 ? "#78C962" : "#FB9145"],
        },
        plotOptions: {
            radialBar: {
                hollow: {
                    size: "75%",
                },
                track: {
                    background: "#C4C4C4",
                    strokeWidth: "35%",
                    margin: 2,
                },
                dataLabels: {
                    showOn: "always",
                    value: {
                        offsetY: -5,
                        color: "#082254",
                        fontSize: "24px",
                        show: true,
                        fontFamily: "Montserrat",
                        fontWeight: "600",
                    },
                },
            },
        },
    };
    const series = [relativeRating];

    return (
        <Card borderRadius={"giant"} className={styles.container}>
            <div className={styles.chart}>
                <Chart
                    options={options}
                    series={series}
                    type="radialBar"
                    width={isDesktop ? "255" : "200"}
                />
            </div>
            <div className={styles.subTitleContainer}>
                <Subtitle size={"subtitle-2"} className={styles.subTitle}>
                    Рейтинг спортcмена относительно рекордов по этапу подготовки РФ
                </Subtitle>
            </div>
        </Card>
    );
}

SportsmanRelativeRating.propTypes = {
    relativeRating: PropTypes.number.isRequired,
};
